{
  "collect": "नमूना संग्रह करें",
  "track": "नमूना ट्रैक करें",
  "accession": "एक्सेशन संख्या",
  "barcode": "बारकोड",
  "status": {
    "ordered": "आदेशित",
    "collected": "संग्रहित",
    "inTransit": "परिवहन में",
    "received": "प्राप्त",
    "processing": "प्रसंस्करण में",
    "resulted": "परिणाम जारी",
    "rejected": "Rejected",
    "in_transit": "परिवहन में"
  },
  "title": "Specimens",
  "loading": "Loading specimens…",
  "errorState": "Could not load specimens.",
  "emptyState": "No specimens for this patient.",
  "noRejectionReason": "Rejected — no reason recorded",
  "columns": {
    "accession": "Accession",
    "type": "Type",
    "status": "Status",
    "collected": "Collected",
    "received": "Received",
    "location": "Location"
  }
}
